import { useState, useEffect } from "react";
import { getPortLocalDatetime } from "../helpers/TimezoneHelper";

export const usePortLocalDatetime = (port, datetime) => {
  const [state, setState] = useState({ value: "", loading: false, error: null });

  useEffect(() => {
    let active = true;

    if (!port || !datetime) {
      setState({ value: "", loading: false, error: null });
      return;
    }

    setState({ value: "", loading: true, error: null });

    const fetchData = async () => {
      try {
        const result = await getPortLocalDatetime(port, datetime);
        if (active) {
          setState({ value: result, loading: false, error: null });
        }
      } catch (err) {
        if (active) {
          setState({ value: "Error", loading: false, error: err });
        }
      }
    };

    fetchData();

    return () => { active = false; };
  }, [port, datetime]);

  return state;
};
